import { Box } from 'fbm-ui';
import { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

const Login = () => {
  const { token } = useParams();
  const [searchParams] = useSearchParams();

  const positionToken = searchParams.get('positionToken');

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      localStorage.setItem('id_token', token);
      navigate(`/login/${positionToken}`, { replace: true });
    }
  }, [token, positionToken, navigate]);

  return <Box height={1} p={2} sx={{ background: 'white' }} />;
};

export default Login;
